import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ExistsMasterDataResponseData } from '@/coreInfrastructureModule/axios/generated/registerBusinessManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IRegisterBusinessRepository } from '@/coreInfrastructureModule/interfaces/IRegisterBusinessRepository';

/**
 * 新規選択肢追加で追加した選択肢が既存のマスタ情報と重複していないかどうかをチェックするクラス
 */
export class CheckNewOptionDuplicateUseCase {
  private repository: IRegisterBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IRegisterBusinessRepository) {
    this.repository = repository;
  }
  /**
   * マスタ情報重複チェック
   * @param existsTargetItemType - チェックする情報のタイプ
   * @param code - チェックするコード(**Code)
   * @param value - チェックする値(**Name)
   * @returns - 重複しているかどうか、している場合は重複しているデータも返す
   */
  public async execute(
    existsTargetItemType: string,
    code: string,
    value: string
  ): Promise<INetworkResult<ExistsMasterDataResponseData, IError>> {
    try {
      const response = await this.repository.getExistsMasterData(existsTargetItemType, code, value);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: response.status.data.data,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました。',
          },
        },
      };
    }
  }
}
